import React from 'react';
import { Header } from '../../common/header.component';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { Rbac, useRbac } from '../../common/Rbac';
import { RbacObject } from '../../../export-types/cleaned-types';
import Dropdown from 'rsuite/Dropdown';
import { ModalsService } from '../../../services/modals.service';
import { CustomsDeliveryDutyEditModal } from './duty/customs-duty-edit-modal';
import { trpcSwr } from '../../../api/trpc';
import { AlertService } from '../../../services/alert.service';
import { CustomsDeliveryTrueSignEditModal } from './true-sign/customs-true-sign-edit-modal';

export type OutletContextParams = {
  debouncedInternalId: string;
};

export const CustomsDeliveriesScreen = () => {
  const { hasPermission } = useRbac();
  const navigate = useNavigate();
  const { trigger: createDuty } =
    trpcSwr.customsDeliveryDuty.createCustomsDuty.useSWRMutation({
      onError: (e) => {
        AlertService.error(e.message);
      },
      onSuccess: () => {
        AlertService.success();
      },
    });

  const { trigger: createTrueSign } =
    trpcSwr.customsDeliveryTrueSign.createCustomsTrueSign.useSWRMutation({
      onError: (e) => {
        AlertService.error(e.message);
      },
      onSuccess: () => {
        AlertService.success();
      },
    });
  return (
    <>
      <Header>
        <div className="d-flex flex-row gap-4">
          <h1>
            <FormattedMessage
              defaultMessage="ВЭД доставки"
              id="customDeliveries.title.customsDeliveries"
              description="Заголовок страницы"
            />
          </h1>
          <div>
            <Dropdown
              toggleClassName="btn btn-success"
              placement="bottomEnd"
              title="Добавить"
              trigger="click"
              onSelect={(eventKey) => {
                if (eventKey === 1) {
                  navigate('/customs-deliveries/create');
                }
                if (eventKey === 2) {
                  navigate(`/customs-deliveries/delivery-methods/create`);
                }
                if (eventKey === 3) {
                  navigate(`/customs-deliveries/delivery-supports/create`);
                }
                if (eventKey === 4) {
                  ModalsService.createModal(CustomsDeliveryDutyEditModal, {
                    title: 'Добавить новый сбор',
                    onSubmit: async (data) => {
                      await createDuty(data);
                    },
                  });
                }
                if (eventKey === 5) {
                  ModalsService.createModal(CustomsDeliveryTrueSignEditModal, {
                    title: 'Добавить новый тариф честного знака',
                    onSubmit: async (data) => {
                      await createTrueSign(data);
                    },
                  });
                }
              }}
            >
              {hasPermission(RbacObject.CustomsDelivery, 'write') && (
                <>
                  <Dropdown.Item eventKey={1}>
                    <i className="bi bi-plus-circle-fill" />
                    <span className="ps-2">Заказ ВЭД</span>
                  </Dropdown.Item>
                </>
              )}
              {hasPermission(RbacObject.CustomsDelivery, 'write:settings') && (
                <>
                  <Dropdown.Item eventKey={2}>
                    <i className="bi bi-truck" />
                    <span className="ps-2">Способ доставки</span>
                  </Dropdown.Item>
                </>
              )}
              {hasPermission(RbacObject.CustomsDelivery, 'write:settings') && (
                <>
                  <Dropdown.Item eventKey={3}>
                    <span className="">% Сопровождение поставки</span>
                  </Dropdown.Item>
                </>
              )}
              {hasPermission(RbacObject.CustomsDelivery, 'write:settings') && (
                <>
                  <Dropdown.Item eventKey={4}>
                    <span className="">Таможенный сбор</span>
                  </Dropdown.Item>
                </>
              )}
              {hasPermission(RbacObject.CustomsDelivery, 'write:settings') && (
                <>
                  <Dropdown.Item eventKey={5}>
                    <span className="">Тариф честный знак</span>
                  </Dropdown.Item>
                </>
              )}
            </Dropdown>
          </div>
        </div>
      </Header>
      <ul className="nav nav-pills d-inline-flex align-self-start mb-3">
        <Rbac object={RbacObject.CustomsDelivery} action={'read'}>
          <li className="nav-item">
            <NavLink
              to="/customs-deliveries/orders"
              className="nav-link text-decoration-none"
            >
              <FormattedMessage
                defaultMessage="Выкупы"
                id="customsDeliveries.label.redemptions"
                description="Надпись на вкладке"
              />
            </NavLink>
          </li>
        </Rbac>
        <Rbac object={RbacObject.CustomsDelivery} action={'read:settings'}>
          <li className="nav-item">
            <NavLink
              to="/customs-deliveries/settings"
              className="nav-link text-decoration-none"
            >
              <FormattedMessage
                defaultMessage="Комиссии ВЭД"
                id="customsDeliveries.label.settings"
                description="Надпись на вкладке"
              />
            </NavLink>
          </li>
        </Rbac>
        <Rbac object={RbacObject.CustomsDelivery} action={'read:settings'}>
          <li className="nav-item">
            <NavLink
              to="/customs-deliveries/delivery-methods"
              className="nav-link text-decoration-none"
            >
              <FormattedMessage
                defaultMessage="Способы доставки"
                id="customsDeliveries.label.deliveryMethods"
                description="Надпись на вкладке"
              />
            </NavLink>
          </li>
        </Rbac>
        <Rbac object={RbacObject.CustomsDelivery} action={'read:settings'}>
          <li className="nav-item">
            <NavLink
              to="/customs-deliveries/duties"
              className="nav-link text-decoration-none"
            >
              <FormattedMessage
                defaultMessage="Таможенный сбор"
                id="customsDeliveries.label.duties"
                description="Надпись на вкладке"
              />
            </NavLink>
          </li>
        </Rbac>
        <Rbac object={RbacObject.CustomsDelivery} action={'read:settings'}>
          <li className="nav-item">
            <NavLink
              to="/customs-deliveries/delivery-supports"
              className="nav-link text-decoration-none"
            >
              <FormattedMessage
                defaultMessage="Комиссии за сопровождение"
                id="customsDeliveries.label.support"
                description="Надпись на вкладке"
              />
            </NavLink>
          </li>
        </Rbac>
        <Rbac object={RbacObject.CustomsDelivery} action={'read:settings'}>
          <li className="nav-item">
            <NavLink
              to="/customs-deliveries/true-sign"
              className="nav-link text-decoration-none"
            >
              <FormattedMessage
                defaultMessage="Тарифы честный знак"
                id="customsDeliveries.label.support"
                description="Надпись на вкладке"
              />
            </NavLink>
          </li>
        </Rbac>
      </ul>

      <Outlet />
    </>
  );
};
